import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "SurveyList",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        },
        surveys() {
            return this.$store.state.surveyModule.surveys;
        }
    },
    created() {
        this.headers = [{
            text: this.$t('GeneralTranslations.Name'),
            align: "start",
            value: "name"
        },
        {
            text: this.$t('SurveyList.Audience'),
            value: "audience"
        },
        {
            text: this.$t('SurveyList.DatePublished'),
            value: "publishedDatetime"
        },
        {
            text: this.$t('GeneralTranslations.Status'),
            value: "status"
        },
        {
            text: this.$t('SurveyList.CompletedSurveys'),
            value: "r"
        }]
        this.$store.dispatch("getSurveys", this.showArchived);
    },
    data() {
        return {
            currentDate: new Date().getDate(),
            search: "",
            dialog: false,
            showArchived: false,
            newSurveyName: "",
            headers: []
        };
    },
    watch: {
        showArchived(newValue) {
            this.$store.dispatch("getSurveys", newValue);
        }
    },
    methods: {
        handleClickSurvey(row) {
            this.$store.dispatch("getSurvey", {
                id: row.id.toString(),
                isRoute: true
            });
        },
        createSurvey() {
            this.$store.dispatch("createSurvey", this.newSurveyName);
        },
        closeCreateSurveyDlg() {
            this.dialog = false;
            this.newSurveyName = "";
            this.$refs.observer.reset();
        },
        routeToSurveyCreate() {
            this.$router.push("/survey-create");
        }
    }
};